import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ChartTypeSRBM } from 'components/DevicesDetail/MCT/ChartType/MCTChartType';

export interface DeviceDetailPageState {
  currentSRBMChartType: ChartTypeSRBM;
}

export const initialState: DeviceDetailPageState = {
  currentSRBMChartType: ChartTypeSRBM.BaitStationChart,
};

const devicesDetailPageSliceSRBM = createSlice({
  name: 'DevicesDetailPagesSRBM',
  initialState,
  reducers: {
    setCurrentChartTypeSRBM(state, action: PayloadAction<ChartTypeSRBM>) {
      state.currentSRBMChartType = action.payload;
    },
  },
});

export const { setCurrentChartTypeSRBM } = devicesDetailPageSliceSRBM.actions;

export default devicesDetailPageSliceSRBM.reducer;
